<template>
  <div class="register absolute">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/images/logo2.png" v-else />
      </div>
      <h2 class="logoTitle">名品mall</h2>
    </div>
    <br>    
    <div class="whiteBg">
      <div class="tip">
        <a href="https://admin.hdmingpinmall.com/api/appUpdate"><span class="font-color-red">APP下载</span></a>
      </div>
    </div>
<br><br><br><br><br><br>

    <div class="v"> <a href="https://beian.miit.gov.cn">{{ v }}</a></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      v: '沪ICP备20008395号',
    };
  },
  mounted: function() {

  },
  methods: {

  }
};
</script>
<style scoped>

.font-color-white{
    color: #ffffff;
    font-size: .4rem;
}
.align-center{
    text-align: center;
}
.register .whiteBg {
  width: 4.2rem;
  padding: 0;
}
.register .shading {
  height: auto;
  padding-top: 3.5rem;
  
}
.logoTitle {
  text-align: center;
  color: white;
  font-size: 0.5rem;
  margin: 0.3rem;
  margin-top: 0.1rem;
}
.v {
  text-align: center;
  margin-top: 1rem;
  
  /* display: none; */
}
.v a{
    color: #ffffff;
}
</style>
